// extracted by mini-css-extract-plugin
export default {"imgAckStatusOverlay":"attendance-detail-modal_imgAckStatusOverlay__30oOo"};